import { MessageOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import React from 'react';
import type { EmptyStateIndicatorProps } from 'stream-chat-react';

const { Text } = Typography;

/**
 * Stream's own empty state is a bare "No chats here yet". Ours says what the space is for and
 * what happens when it is used, for the message list and for an empty channel list alike.
 */
export const ChatEmptyState: React.FC<EmptyStateIndicatorProps> = ({ listType }) => {
  const isChannelList = listType === 'channel';

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: 8,
        padding: '48px 24px',
        height: '100%',
        color: 'rgba(0, 0, 0, 0.45)',
      }}
    >
      <MessageOutlined style={{ fontSize: 40, color: '#91d5ff' }} />
      <Text strong style={{ fontSize: 15 }}>
        {isChannelList ? 'No conversations yet' : 'No messages yet'}
      </Text>
      <Text type="secondary" style={{ maxWidth: 320 }}>
        {isChannelList
          ? 'Conversations with customers who use the Umoto app will appear here.'
          : 'Write the first message below. The customer is notified in the Umoto app and can reply from there.'}
      </Text>
    </div>
  );
};
